import { createContext } from 'react';

export type ReportType = 'astrology' | 'lunar';

export interface PendingReport {
  id: string; // `${profileId}:${reportType}`
  profileId: string;
  sessionId: string;
  reportType: ReportType;
  token?: string | null;
}

export interface ReportNotification {
  id: string;
  profileId: string;
  sessionId: string;
  reportType: ReportType;
  status: 'completed' | 'failed';
  reportUrl?: string;
  errorMessage?: string;
  token?: string | null;
  createdAt: string;
  announced?: boolean;
}

export interface ReportTrackerContextValue {
  pendingReports: PendingReport[];
  notifications: ReportNotification[];
  trackReports: (reports: PendingReport[]) => void;
  clearPending: (predicate: (report: PendingReport) => boolean) => void;
  acknowledgeNotification: (id: string) => void;
  markNotificationAnnounced: (id: string) => void;
}

export const ReportTrackerContext = createContext<ReportTrackerContextValue | undefined>(undefined);
